import styled from 'styled-components';
import { devices, theme } from '@/styles/theme/index.jsx';

export const StyledContactForm = styled.section`
    position: relative;
    margin-top: -1px;
    padding: 80px 0 120px;
    z-index: -1;
    margin-bottom: -1px;

    .next-video-container {
        ${theme.fullHeightWidth}
        ${theme.absoluteFill}
        z-index: 1;
        object-fit: cover;

        .next-video-bg-text {
            display: block;
            padding: 0 !important;
        }

        .next-video-bg {
            ${theme.fullHeightWidth}
            ${theme.absoluteFill}
            z-index: 1;
            object-fit: cover;
        }

        .video-container {
            position: relative;
            ${theme.fullHeightWidth}
            z-index: 2;
        }

        video {
            ${theme.absoluteFill}
            object-fit: cover;
            ${theme.fullHeightWidth}
        }
    }

    video {
        ${theme.absoluteFill}
        ${theme.fullHeightWidth}
        object-fit: cover;
    }

    .contact-row {
        padding-top: 60px;
        &:after {
            width: calc(100% - 30px);
            height: 1px;
            margin: 0 auto;
            content: '';
           ${theme.absoluteFillTopTop}
            background: ${theme.colors.themeColor6};
            ${devices.sm} {
                ${theme.displayNone}
            }
        }

        ${devices.sm} {
            padding-top: 0;
        }
    }

    .short_desc {
        ${theme.blogText}
        color: ${theme.colors.white};
        margin-bottom: 80px;
    }

    .container {
        position: relative;
        z-index: 33;
    }


    .close-button-ygen {
        ${theme.contactCloseButton}
    }

    &.asModal {
        background: ${theme.colors.white};
        ${theme.absoluteFill}
        ${theme.fullHeightWidth}
        margin: 0;
    }


    .d-flex {
        ${theme.flexCol}
        position: relative;
        z-index: 3;

        .single-item {
            display: flex;
            gap: 30px;
            margin-bottom: 30px;
            color: ${theme.colors.white};

            svg {
                path {
                    transition: ${theme.transition};
                }
            }

            p {
                color: ${theme.colors.white};
                ${theme.contactFormText}

            }

            a {
                color: ${theme.colors.white};
                ${theme.contactFormText}
                transition: ${theme.transition};

                &:hover {
                    color: ${theme.colors.secondaryGreen} !important;
                }
            }

            &:last-child {
                margin-bottom: 0;
            }

            svg {
                path {
                    transition: ${theme.transition};
                }
            }

            &:hover {
                svg {
                    path {
                        animation: ${theme.animations.bounce} 1s infinite;
                    }
                }
            }
        }
    }


    ${devices.md} {

        .list_with_form {
            margin-top: 40px;
        }

    }

    ${devices.sm} {
        padding: 95px 0;
        .title {
            margin-bottom: 70px;
            width: 100%;
            position: relative;
            padding-bottom: 16px;
            &:after {
                width: 100%;
                height: 1px;
                margin: 0 auto;
                content: '';
                background: ${theme.colors.themeColor6};
                ${theme.absoluteFillBottom}

            }
        }

        .social-item-wrapper {
            margin-bottom: 80px;
        }

    }





`;